import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PaywallCheckoutPreview } from "@circle-react/types/Paywall";
import type {
  PaywallPrice,
  PaywallPriceScenario,
} from "@circle-react/types/PaywallPrice";

import { t } from "@/i18n-js/instance";
import { Badge } from "@/react/components/SettingsApp/CompassCompat/Badge";

import type { StatusBadgeProperty } from "./constants";

interface PriceBadgeProps {
  preview?: PaywallCheckoutPreview;
  price?: Pick<PaywallPrice, "scenario" | "trial_days">;
  properties: Record<PaywallPriceScenario, StatusBadgeProperty | null>;
}

export const PriceBadge = ({ price, preview, properties }: PriceBadgeProps) => {
  if (!price && !preview) {
    return null;
  }

  const index = price?.scenario || preview?.preview_scenario || "value";
  const property = properties[index];

  if (property) {
    return (
      <Badge
        label={t([property.labelLocale], { count: price?.trial_days })}
        className={classNames("rounded-md border-0", property.className)}
        variant={property.variant}
        labelClassName={property.labelClassName}
        textSizeClassName="text-xs"
      />
    );
  }

  return null;
};
